import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

import { ProductUserType } from '@products/interfaces/product-user-type';

@Injectable({
  providedIn: 'root',
})
export class ProductRegistrationUserTypeStatementGuard {
  constructor(private readonly router: Router) {}
  canActivate(route: ActivatedRouteSnapshot): UrlTree | boolean {
    const userType = route.queryParams['userType'];
    const productId = route.queryParams['id'];
    if (productId || (userType && ProductUserType.includes(userType))) {
      return true;
    }

    return this.router.createUrlTree(['/products']);
  }
}
